// 组件 - 审版组件
import request from "@/utils/request";

// 获取审版记录
export function getHouseReview(data) {
  return request({
    url: "/pdm/pdmHouseReview/queryAllById/" + data,
    method: "get"
  });
}

// 获取模特数据
export function getModelInformation(data) {
  return request({
    url: "/pdm/pdmModelInformation/queryModelList",
    method: "post",
    data: data
  });
}

// 增加或更新模特信息
export function updateOrInsertModelInfo(data) {
  return request({
    url: "/pdm/pdmModelInformation/updateOrInsert",
    method: "post",
    data: data
  });
}

// 获取审版意见模板
export function getReviewComments(data) {
  return request({
    url: "/pdm/configContentsReviewOpinions/queryAll",
    method: "post",
    data: data
  });
}

// 增加或更新版房审版处理意见
export function updateOrInsertComments(data) {
  return request({
    url: "/pdm/configContentsReviewOpinions/updateOrInsert",
    method: "post",
    data: data
  });
}

// 删除版房审版处理意见
export function deleteReviewOpinions(data) {
  return request({
    url: "/pdm/configContentsReviewOpinions/delete/" + data,
    method: "get"
  });
}

// 获取设计版单信息
export function queryplateMessage(data) {
  return request({
    url: "/pdm/pdmPlateOrder/queryplateMessage/" + data,
    method: "get"
  });
}

// 获取打版要求信息
export function queryPrintingRequire(data) {
  return request({
    url: "/pdm/pdmPlateOrder/printingRequire/" + data,
    method: "get"
  });
}

// 获取打版要求信息
export function queryCommonAttachment(data) {
  return request({
    url: "/pdm/commonAttachment/queryCommonAttachmentByUUID?uuid=" + data,
    method: "get"
  });
}

// 样衣审版详情-保存
export function saveSampleReviewDetails(plateOrderId, data) {
  return request({
    url: "/pdm/pdmHouseReview/saveSampleReviewDetails/" + plateOrderId,
    method: "post",
    data: data
  });
}

// 样衣审版详情-提交
export function submitSampleReviewDetails(plateOrderId, data) {
  return request({
    url: "/pdm/pdmHouseReview/submitSampleReviewDetails/" + plateOrderId,
    method: "post",
    data: data
  });
}

// 纸样完成登记-保存
export function savePatternRegistCompleted(plateOrderId, data) {
  return request({
    url: "/pdm/pdmHouseReview/savePatternRegistCompleted/" + plateOrderId,
    method: "post",
    data: data
  });
}

// 纸样完成登记-提交
export function submitPatternRegistCompleted(plateOrderId, data) {
  return request({
    url: "/pdm/pdmHouseReview/submitPatternRegistCompleted/" + plateOrderId,
    method: "post",
    data: data
  });
}

// 文件下载
export function downloadFile(data) {
  return request({
    url: "/pdm/commonAttachment/download",
    method: "post",
    data: data
  });
}